<template>
  <section class="py-16 sm:py-24 overflow-x-hidden">
    <div class="container" data-aos="fade-up" data-aos-duration="600">
      <div class="grid xl:grid-cols-4 grid-cols-3 gap-6">
        <div class="col-span-3 lg:col-span-1">
          <span
            class="text-sm font-medium py-1 px-3 rounded-full text-primary bg-primary/10"
          >
            Geri Dönütler
          </span>
          <h1 class="text-3xl/tight font-medium mt-3 mb-4">
            Kullanıcılarımız Bizim Hakkımızda Ne Düşünüyor?
          </h1>
          <div class="flex gap-4 mt-10">
            <button
              ref="prevButton"
              class="button-prev text-xl transition-all duration-300 hover:text-primary"
            >
              <i class="fa-solid fa-arrow-left"></i>
            </button>
            <button
              ref="nextButton"
              class="button-next text-xl transition-all duration-300 hover:text-primary"
            >
              <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </div>

        <div class="col-span-3 lg:col-span-2 xl:col-span-3">
          <div class="relative">
            <swiper
              :modules="[SwiperNavigation, SwiperPagination]"
              :slides-per-view="1"
              :navigation="{ prevEl: prevButton, nextEl: nextButton }"
              :pagination="{ clickable: true }"
              class="swiper"
            >
              <swiper-slide
                v-for="(testimonial, index) in testimonials"
                :key="index"
                class="p-10 border rounded-xl bg-white shadow"
              >
                <i class="fa-solid fa-quote-left text-gray-500 text-5xl"></i>
                <p class="my-4">{{ testimonial.Text }}</p>
                <div class="border-b border-gray-200 w-full my-7"></div>
                <div class="flex items-center gap-2">
                  <div>
                    <h1 class="text-sm mb-1">{{ testimonial.Name }}</h1>
                    <p class="text-gray-500 text-xs">
                      {{ testimonial.Position }}
                    </p>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  Navigation as SwiperNavigation,
  Pagination as SwiperPagination,
} from "swiper/modules";

import { useFeedbackStore } from "@/stores/feedbacksStore";

const feedbacksStore = useFeedbackStore();

const testimonials = ref(null);

const prevButton = ref(null);
const nextButton = ref(null);

onMounted(async () => {
  await feedbacksStore.fetchFeedbacks();
  testimonials.value = feedbacksStore.feedbacks;

  prevButton.value = document.querySelector(".button-prev");
  nextButton.value = document.querySelector(".button-next");
});
</script>

<style scoped>
.swiper {
  width: 100%;
  height: auto;
}
</style>
